import { useState } from "react";
import { type FieldValues } from "react-hook-form";
import { EyeIcon } from "@components/icons";
import {
  FormInput,
  type TFormInputProps,
} from "@components/inputs/form/FormInput/FormInput";

export const FormPasswordInput = <T extends FieldValues>(
  props: TFormInputProps<T>,
) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  return (
    <FormInput
      {...props}
      type={isPasswordShown ? "text" : "password"}
      iconRight={EyeIcon}
      onRightIconKeyDown={(e) => {
        if (e.key !== "Tab") {
          e.preventDefault();
          setIsPasswordShown(true);
        }
      }}
      onRightIconKeyUp={(e) => {
        if (e.key !== "Tab") {
          e.preventDefault();
          setIsPasswordShown(false);
        }
      }}
      onRightIconMouseDown={(e) => {
        e.preventDefault();
        setIsPasswordShown(true);
      }}
      onRightIconMouseUp={(e) => {
        e.preventDefault();
        setIsPasswordShown(false);
      }}
      onRightIconTouchStart={(e) => {
        e.preventDefault();
        setIsPasswordShown(true);
      }}
      onRightIconTouchEnd={(e) => {
        e.preventDefault();
        setIsPasswordShown(false);
      }}
    />
  );
};
